/**
 * ScrollableList.jsx
 * Created by Madhusudan Ravi on 5/2/2019.
 *
 * Note that role="list" and role="listitem" are used because some screen readers
 * will not detect a list properly if the list styling is removed.
 */

/* eslint-disable jsx-a11y/no-redundant-roles */

import React from 'react';
import PropTypes from 'prop-types';

export default class ScrollableListItem extends React.Component {
    static propTypes = {
        /** Contents of the list item */
        children: PropTypes.node.isRequired
    }

    render() {
        return (
            <li
                data-component="ScrollableListItem"
                role="listitem">
                {this.props.children}
            </li>
        )
    }
}
